export default __webpack_public_path__ + "img/dHosJiKH.92f25f49.svg";